import type { Dispatch, FC, ReactNode, SetStateAction } from "react";

import { Box, Modal } from "@mui/material";
import { getActiveWebUrl } from "../../../services/selectors/web-selectors";
import { useSelector } from "react-redux";

interface BrandingPreviewProps {
  modalOpen: boolean;
  children: ReactNode;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
}

export const BrandingPreview: FC<BrandingPreviewProps> = ({
  modalOpen,
  setModalOpen,
  children,
}) => {
  const url = useSelector(getActiveWebUrl);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 5 }}>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby='modal-title'
        aria-describedby='modal-description'
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 1300,
            height: 800,
            bgcolor: "background.paper",
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          {children}
          <iframe
            src={
              url
                ? url.match(/^https?:\/\//)
                  ? url
                  : "https://" + url
                : "https://www.overenyweb.cz/"
            }
            style={{
              width: "100%",
              height: "100%",
              border: "1px solid #ccc",
              background: "#fff",
            }}
            title='Notification'
          />
        </Box>
      </Modal>
    </Box>
  );
};
